import { createContext, useContext } from 'react';
import { type FormFields } from '../types';

export const FormFieldsContext = createContext<FormFields | undefined>(
  undefined,
);

export function useFormFields(): FormFields {
  const context = useContext(FormFieldsContext);
  if (context === undefined) {
    throw new Error('useFormFields must be used within a FormFieldsProvider');
  }
  return context;
}
